import React, { useState, useEffect } from'react';
import { useParams } from'react-router-dom';
import { db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Article, Article2, Article3, Article4 } from '../../@/components';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from'react-responsive';
import './teamDetails.css';

const TeamDetails = () => {
  const { slug } = useParams();
  const [teamMember, setTeamMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isDesktop = useMediaQuery({ minWidth: 769 }); 
  const isNotDesktop = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    const fetchTeamMember = async () => {
      const teamMemberRef = collection(db, 'team-members');
      const q = query(teamMemberRef, where('slug', '==', slug));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.docs.length > 0) {
        setTeamMember(querySnapshot.docs[0].data());
      }
    };
    fetchTeamMember();
  }, [slug]);

  if (!teamMember) {
    return <p>Team member not found.</p>;
  }

  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading issues...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Team Details...</p>
      </div>
    );
  }
  

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: false, 
    centerMode: false, 
    centerPadding: '0', 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: true,
          centerPadding: '10%',
          infinite: true,
        }
      }
    ]
  };

  return (
    <div className="teamDetails" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <div className="ulev__tdetails section__padding">
        <div className='ulev__tdetails-container'>
          <div className='ulev__tdetails-container_groupA'>
            <Article
              photos={teamMember.photos}
              name={teamMember.name}
              title={teamMember.title}
              text={teamMember.position}
              moreBio={isNotDesktop? teamMember.morebio : undefined}
              sliderSettings={sliderSettings}
            />
          </div>
          {isDesktop? (
            <div className='ulev__tdetails-container_groupB'>
              <h1 style={{color:"#ffffff", fontSize:"35px", textAlign: "right"}}></h1>
              <Article4 
                moreBio={<span dangerouslySetInnerHTML={{ __html: teamMember.moreBio }} />}
              />
            </div>
          ) : (
            <div className='ulev__tdetails-container_groupB'>
              <h1 className='bio'></h1>
              <Article4 
                moreBio={<span dangerouslySetInnerHTML={{ __html: teamMember.moreBio }} />}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TeamDetails;